var _style, _title, _g;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgIconLikeOn = function SvgIconLikeOn(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26.9 23.6",
    style: {
      enableBackground: "new 0 0 26.9 23.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#E6B81C;}\n")), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "icon_comentar")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_x2F_social_x2F_thumb_x5F_up_x5F_alt_x5F_24px_1_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path-1_2_",
    className: "st0",
    d: "M14.6,1.2L8.2,7.5C7.8,8,7.6,8.5,7.6,9.1v11.5c0,1.3,1,2.3,2.3,2.3h10.3c0.9,0,1.7-0.6,2.1-1.4 l3.7-8.7c1-2.3-0.7-4.8-3.2-4.8h-6.5l1.1-5.3c0.1-0.6-0.1-1.2-0.5-1.6C16.3,0.5,15.2,0.5,14.6,1.2z M3,22.9c1.3,0,2.3-1,2.3-2.3 v-9.2c0-1.3-1-2.3-2.3-2.3s-2.3,1-2.3,2.3v9.2C0.7,21.9,1.7,22.9,3,22.9z"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconLikeOn, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_like_on.d3f7848c.svg";
export { ForwardRef as ReactComponent };